(function () {
	const initProductAccordion = () => {
		$(".about__accordion-toggle").click(function () {
			if (!$(this).hasClass("active")) {
				$(this).addClass("active");
				$(this)
					.siblings(".about__accordion-description")
					.eq($(this).index())
					.stop()
					.slideDown(300);
			} else {
				$(this).removeClass("active");
				$(this).siblings(".about__accordion-description").stop().slideUp(300);
			}
		});
	};

	const initZoomImage = () => {
		const imagesWrapper = document.querySelector(
			".product-media-modal__content"
		);
		if (!imagesWrapper) return;
		const images = imagesWrapper.querySelectorAll(".js-image-zoom");

		images.forEach((el) => {
			el.addEventListener("click", (e) => {
				imagesWrapper.classList.toggle("zoom");
			});
		});
	};

	const initProductMediaModalZoom = () => {
		document.querySelectorAll("product-modal").forEach((modal) => {
			if (modal.dataset.dornaZoomReady === "true") return;
			const content = modal.querySelector(".product-media-modal__content");
			if (!content) return;

			modal.dataset.dornaZoomReady = "true";
			const state = {
				scale: 1,
				x: 0,
				y: 0,
				pointers: new Map(),
				panStart: null,
				pinchStart: null,
				touchStartX: null,
				touchStartY: null,
				lastTapTime: 0,
			};

			const getActiveImage = () => modal.querySelector(".product-media-modal__item.active img");
			const getDistance = (pointA, pointB) => Math.hypot(pointA.x - pointB.x, pointA.y - pointB.y);
			const clampPan = (x, y) => {
				const image = getActiveImage();
				if (!image || state.scale <= 1) return { x: 0, y: 0 };
				const maxX = Math.max(0, (image.offsetWidth * state.scale - content.clientWidth) / 2);
				const maxY = Math.max(0, (image.offsetHeight * state.scale - content.clientHeight) / 2);
				return {
					x: Math.min(Math.max(x, -maxX), maxX),
					y: Math.min(Math.max(y, -maxY), maxY),
				};
			};
			const applyZoom = () => {
				const image = getActiveImage();
				content.classList.toggle("is-zoomed", state.scale > 1);
				if (!image) return;
				image.style.transform = state.scale > 1
					? `translate3d(${state.x}px, ${state.y}px, 0) scale(${state.scale})`
					: "";
				image.style.cursor = state.scale > 1 ? "grab" : "";
			};
			const setZoom = (scale, x = 0, y = 0) => {
				state.scale = Math.min(Math.max(scale, 1), 2.6);
				const clamped = clampPan(x, y);
				state.x = clamped.x;
				state.y = clamped.y;
				applyZoom();
			};
			const resetZoom = () => {
				state.scale = 1;
				state.x = 0;
				state.y = 0;
				state.pointers.clear();
				state.panStart = null;
				state.pinchStart = null;
				applyZoom();
			};
			const toggleZoom = (clientX, clientY) => {
				if (state.scale > 1) {
					resetZoom();
					return;
				}
				const image = getActiveImage();
				const rect = image?.getBoundingClientRect();
				if (!rect) return;
				setZoom(2.1, (rect.left + rect.width / 2 - clientX) * 1.15, (rect.top + rect.height / 2 - clientY) * 1.15);
			};

			content.addEventListener("pointerdown", (event) => {
				if (event.target.closest(".product-media-modal__nav, .product-media-modal__toggle")) return;
				content.setPointerCapture?.(event.pointerId);
				state.pointers.set(event.pointerId, { x: event.clientX, y: event.clientY });
				state.touchStartX = event.clientX;
				state.touchStartY = event.clientY;

				if (state.pointers.size === 2) {
					const points = Array.from(state.pointers.values());
					state.pinchStart = {
						distance: getDistance(points[0], points[1]),
						scale: state.scale,
					};
					return;
				}

				if (state.scale > 1) {
					event.preventDefault();
					state.panStart = {
						x: event.clientX,
						y: event.clientY,
						zoomX: state.x,
						zoomY: state.y,
					};
				}
			}, { passive: false });

			content.addEventListener("pointermove", (event) => {
				if (!state.pointers.has(event.pointerId)) return;
				state.pointers.set(event.pointerId, { x: event.clientX, y: event.clientY });

				if (state.pointers.size === 2 && state.pinchStart) {
					event.preventDefault();
					const points = Array.from(state.pointers.values());
					setZoom(state.pinchStart.scale * (getDistance(points[0], points[1]) / state.pinchStart.distance), state.x, state.y);
					return;
				}

				if (state.scale > 1 && state.panStart) {
					event.preventDefault();
					setZoom(
						state.scale,
						state.panStart.zoomX + event.clientX - state.panStart.x,
						state.panStart.zoomY + event.clientY - state.panStart.y
					);
				}
			}, { passive: false });

			const endPointer = (event) => {
				state.pointers.delete(event.pointerId);
				state.panStart = null;
				if (state.pointers.size < 2) state.pinchStart = null;
			};

			content.addEventListener("pointerup", (event) => {
				const deltaX = event.clientX - state.touchStartX;
				const deltaY = event.clientY - state.touchStartY;
				const moved = Math.abs(deltaX) > 8 || Math.abs(deltaY) > 8;
				endPointer(event);

				if (state.scale > 1) {
					if (!moved) {
						const now = Date.now();
						if (now - state.lastTapTime < 320) {
							resetZoom();
							state.lastTapTime = 0;
						} else {
							state.lastTapTime = now;
						}
					}
					return;
				}
				if (moved) return;

				const now = Date.now();
				if (now - state.lastTapTime < 320) {
					toggleZoom(event.clientX, event.clientY);
					state.lastTapTime = 0;
					return;
				}
				state.lastTapTime = now;
			});

			content.addEventListener("pointercancel", endPointer);
			content.addEventListener("lostpointercapture", endPointer);
			content.addEventListener("dblclick", (event) => {
				if (event.target.closest(".product-media-modal__nav, .product-media-modal__toggle")) return;
				toggleZoom(event.clientX, event.clientY);
			});

			modal.querySelectorAll(".product-media-modal__nav, .product__media-subitem").forEach((control) => {
				control.addEventListener("click", resetZoom);
			});

			const observer = new MutationObserver(() => {
				if (modal.hasAttribute("open")) {
					document.body.classList.add("product-media-modal-open");
					return;
				}
				document.body.classList.remove("product-media-modal-open");
				resetZoom();
			});
			observer.observe(modal, { attributes: true, attributeFilter: ["open"] });
		});
	};

	const initDornaImpactBadge = () => {
		if (window.dornaImpactBadgeReady) return;
		window.dornaImpactBadgeReady = true;

		const markImpactBadgeAdded = (formElement) => {
			const productSection = formElement?.closest(".product-section") || document;
			productSection.querySelectorAll("[data-dorna-impact-badge]").forEach((badge) => {
				badge.classList.add("is-added");
			});
		};

		document.addEventListener("variant:add", (event) => {
			markImpactBadgeAdded(event.detail?.formElement);
		});
	};

	const initDornaReviewFallback = () => {
		const reviewRoots = document.querySelectorAll('[data-block-handle="reviews"], .spr-container, .jdgm-widget, .loox-rating, .stamped-main-widget');
		reviewRoots.forEach((root) => {
			const text = root.textContent?.toLowerCase() || "";
			const hasReviewContent = root.querySelector(
				".spr-review, .jdgm-rev, .jdgm-carousel-item, .loox-review, .stamped-review, [data-review-id]"
			);
			const looksEmpty =
				text.includes("be the first") ||
				text.includes("no reviews") ||
				text.includes("0 reviews");

			if (looksEmpty && !hasReviewContent) {
				root.classList.add("dorna-empty-reviews");
			} else {
				root.classList.remove("dorna-empty-reviews");
			}
		});
	};



	const revealPopup = () => {
		const stickyBar = document.querySelector('.product__popup'); // Sticky bar
		const secondSection = document.querySelector('.product-section + section'); // Second section
		const footer = document.querySelector('footer'); // Footer

		// Check if the required elements exist
		if (!stickyBar || !secondSection || !footer) {
				return;
		}

			const getOffset = (element) => {
				const rect = element.getBoundingClientRect();
				return rect.top + window.scrollY;
			};

			const secondSectionMid = getOffset(secondSection);
			const footerTop = getOffset(footer);

			const handleScroll = () => {
				const scrollPosition = window.scrollY + window.innerHeight;
				const activeOffset = window.scrollY > secondSectionMid && scrollPosition < footerTop;

				stickyBar.classList[activeOffset ? "add" : "remove"]('active');
			};

			// Initial check in case the user starts in the middle of the page
			handleScroll();
};

	let revealPopupTicking = false;
	document.addEventListener('scroll', () => {
		if (revealPopupTicking) return;
		revealPopupTicking = true;
		window.requestAnimationFrame(() => {
			revealPopup();
			revealPopupTicking = false;
		});
	}, { passive: true });


	document.addEventListener("shopify:section:load", function () {
		initProductAccordion();
		initZoomImage();
		initProductMediaModalZoom();
		initDornaImpactBadge();
		initDornaReviewFallback();
		revealPopup();
	});

	initProductAccordion();
	initZoomImage();
	initProductMediaModalZoom();
	initDornaImpactBadge();
	initDornaReviewFallback();
	setTimeout(initDornaReviewFallback, 1200);
	setTimeout(initDornaReviewFallback, 3000);
	revealPopup();
})();

class FloatedForm extends HTMLElement {
	constructor() {
		super();
		this.renderForm();
	}

	renderForm() {
		fetch(this.getAttribute("data-product-url"))
			.then((response) => response.text())
			.then((responseText) => {
				const responseHTML = new DOMParser().parseFromString(
					responseText,
					"text/html"
				);
				this.productElement = responseHTML.querySelector(
					'div[id^="ProductInfo-"]'
				);

				this.preventDuplicatedIDs();
				this.removeDOMElements();
				this.setInnerHTML(this, this.productElement.innerHTML);

				if (window.Shopify && Shopify.PaymentButton) {
					Shopify.PaymentButton.init();
				}

				if (window.ProductModel) window.ProductModel.loadShopifyXR();

				this.showMoreFields();
			})
			.finally(() => {
				const selectDropDown = () => {
					$(".product__popup .product-form__controls--dropdown").each(function () {
						const elListItem = $(this).find(".dropdown-select ul li");
						const elItem = $(this).find(".dropdown-select ul");
						const selectedText = $(this).find(
							".dropdown-select .select-label"
						);

						selectedText.on("click", function (e) {
							elItem.toggleClass("active");
							if (elItem.hasClass("active")) {
								e.stopPropagation();
								$(document).click(function () {
									elItem.removeClass("active");
								});
							}
						});

						elListItem.on("click", function () {
							selectedText
								.find("span")
								.text($(this).text())
								.attr("title", $(this).text());
							elItem.removeClass("active");
							document.activeElement.blur();
						});
					});
				};

				selectDropDown();
			});
	}

	setInnerHTML(element, html) {
		element.innerHTML = html;

		// Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
		element.querySelectorAll("script").forEach((oldScriptTag) => {
			const newScriptTag = document.createElement("script");
			Array.from(oldScriptTag.attributes).forEach((attribute) => {
				newScriptTag.setAttribute(attribute.name, attribute.value);
			});
			newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
			oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
		});
	}

	preventDuplicatedIDs() {
		const sectionId = this.productElement.dataset.section;
		this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(
			sectionId,
			`floated-${sectionId}`
		);

		if (this.productElement.querySelectorAll("variant-selects")) {
			this.productElement
				.querySelectorAll("variant-selects")
				.forEach((radio) => {
					radio.dataset.originalSection = sectionId;
				});
		}

		if (this.productElement.querySelectorAll("variant-radios")) {
			this.productElement
				.querySelectorAll("variant-radios")
				.forEach((radio) => {
					radio.dataset.originalSection = sectionId;
				});
		}
	}

	removeDOMElements() {
		const text = this.productElement.querySelector(".product__text");
		if (text) text.remove();

		const tags = this.productElement.querySelector(".product__tags");
		if (tags) tags.remove();

    const title = this.productElement.querySelector(".product__title__wrapper");
		if (title) title.remove();

		const badges = this.productElement.querySelector(".product__custom-badges");
		if (badges) badges.remove();

    const price = this.productElement.querySelector(".price-wrapper");
		if (price) price.remove();

		const description = this.productElement.querySelector(
			".product__description"
		);
		if (description) description.remove();

		const sku = this.productElement.querySelector(".product__sku");
		if (sku) sku.remove();

		const inventory = this.productElement.querySelector(".product__inventory");
		if (inventory) inventory.remove();

		const pickupAvailability = this.productElement.querySelector(
			"pickup-availability"
		);
		if (pickupAvailability) pickupAvailability.remove();

		const customLiquid = this.productElement.querySelector(".custom-liquid");
		if (customLiquid) customLiquid.remove();

		const complementary = this.productElement.querySelector(
			"product-recommendations"
		);
		if (complementary) complementary.remove();

		const shareButtons = this.productElement.querySelector(".share-buttons");
		if (shareButtons) shareButtons.remove();

		const productModal = this.productElement.querySelectorAll(".product-popup");
		productModal.forEach((advantage) => {
			advantage.remove();
		});

		const stickyOnlyRemove = this.productElement.querySelectorAll(
			".dorna-static-color, .dorna-size-selector, .product-parameters, .dorna-product-trust-icons, .dorna-product-material-labels, .dorna-mobile-pdp-trust, .dorna-mobile-quick-notes, .dorna-mobile-new-arrival-proof, .dorna-sticky-atc-button, .dorna-product-impact-line, .dorna-product-impact-badge, .dorna-product-accordion"
		);
		stickyOnlyRemove.forEach((element) => {
			element.remove();
		});

		const productForm = this.productElement.querySelector("floated-form");
		if (productForm) productForm.remove();
	}

	showMoreFields() {
		$(".js-show-more").click(function (e) {
			e.preventDefault();
			$(this).siblings("input").removeClass("hidden");
			$(this).siblings("label").removeClass("hidden");
			$(this).remove();
		});
	}
}

customElements.define("floated-form", FloatedForm);
